import z from "zod";

/**
 * ReportOrdemComprasLoteSchema
 */

export const ReportOrdemComprasLoteSchema = z.object({
  centroCusto: z.coerce.number({
    errorMap: (_) => ({
      message: "Este campo deve ser preenchido!",
    }),
  }),
  fornecedores: z.array(z.number()).optional(),
  status: z.coerce.number({
    errorMap: (_) => ({
      message: "Este campo deve ser preenchido!",
    }),
  }),
  competencia: z.coerce.date({
    errorMap: (_) => ({
      message: "Este campo deve ser preenchido!",
    }),
  }),
}).superRefine((data, ctx) => {
  if (data.centroCusto === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Este campo deve ser preenchido!',
      path: ['centroCusto'],
    });
  }
});

/**
 * ReportOrdemComprasLoteForm
 */

export type ReportOrdemComprasLoteForm = z.infer<typeof ReportOrdemComprasLoteSchema>;